import { SwatchesPicker } from 'react-color'
import { infoSite } from '../../../state/atom'
import { useRecoilState } from 'recoil'
import { useState } from 'react'
import './style.css'

export function ColorPiker() {
  const [colore, setColore] = useRecoilState(infoSite)
  const [colorPiker, setColorPiker] = useState()
  function handleChangeComplete(color: any) {
    const Rgb = color.rgb
    setColore({
      ...colore,
      Colore: {
        Rgba: {
          r: Rgb.r,
          g: Rgb.g,
          b: Rgb.b,
          a: Rgb.a,
        },
      },
    })
    setColorPiker(color.hex)
  }
  return (
    <div className="SwatchesPicker">
      <h4>Colore sito</h4>
      <SwatchesPicker color={colorPiker} onChangeComplete={handleChangeComplete} />
    </div>
  )
}
